import React, { useState, useEffect } from "react";
import "../../Style.css";
import Utils from "../../core/Utils";
import UserHelper from "../../core/UserHelper";
import { connectToStore } from "../../data/store";
import SideBarMenuItems from "../SideBarMenuItems";
import SettingsMenuItems from "../SettingsMenuItems";
import ReportMenuItems from "../ReportMenuItems";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import {
  SideBarMenuNames,
  SettingsMenuList,
  ReportMaxDateLimit,
  UserRoles,
} from "../../core/Constants";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import MessagePopup from "../common/MessagePopUp";
import { Tooltip, Typography } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import { Grid, Box, Container, Stack, Switch } from "@mui/material";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import Loader from "../common/Loader";
import moment from "moment";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import { EmployeeReportPage, LoginPage } from "../../core/PageConstants";
import InputLabel from "@mui/material/InputLabel";
import { getBusiness, getCountry } from "../../data/localSettingsActions";
import { postAsync } from "../../core/serviceClient";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CountryHelper from "../../core/CountryHelper";
import ClearIcon from '@mui/icons-material/Clear';
import AssessmentIcon from '@mui/icons-material/Assessment';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const JobcardsReport = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [reportContent, setReportContent] = useState("");
  const [filterByBranch, setFilterByBranch] = useState(false);
  const [filterByTechBranch, setFilterByTechBranch] = useState(false);
  const [selectedDate, setSelectedDate] = useState([
    Utils.GetStartDate(),
    Utils.GetEndDate(),
  ]);
  const [localSettings, setLocalSettings] = useState(connectToStore());
  const [statementMethod, setStatementMethod] = useState("Summary");
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [selectedTechBranch, setSelectedTechBranch] = useState("");
  const [techBranches, setTechBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState("");
  const [branches, setBranches] = useState([]);
  const [allTechnicians, setAllTechnicians] = useState([]);

  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    }
  };
  const handleFilterByBranchChange = (event) => {
    setFilterByBranch(event.target.checked);
  };

  const handleFilterByTechBranchChange = (event) => {
    setFilterByTechBranch(event.target.checked);
  };

  const handleSubmit = () => {
    getStatementStatus(statementMethod);
  };

  const getStatementStatus = async (statementMethod) => {
    setIsLoading(true);
    let url = "reports/EmployeeReport?";
    const branchId = selectedBranch;
    const UserId = selectedTechBranch;
    let reportUrl =
      Utils.GetServiceUrl() +
      url +
      "branchId=" +
      branchId +
      "&businessId=" +
      localSettings.business.id +
      "&startDate=" +
      Utils.GetISODateTimeString(selectedDate[0]) +
      "&endDate=" +
      Utils.GetISODateTimeString(selectedDate[1]) +
      "&userId=" +
      UserId +
      "&token=" +
      localSettings.token +
      "&token=" +
      localSettings.token +
      "&isDownloadVisible=" +
      true;
    window.open(reportUrl, "_blank");

    setIsLoading(false);
  };

  const handleShowReport = () => {
    setIsLoading(true);
    let url = "reports/EmployeeReport?";
    const branchId = selectedBranch;
    const UserId = selectedTechBranch;
    let reportUrl =
      Utils.GetServiceUrl() +
      url +
      "branchId=" +
      branchId +
      "&businessId=" +
      localSettings.business.id +
      "&startDate=" +
      Utils.GetISODateTimeString(selectedDate[0]) +
      "&endDate=" +
      Utils.GetISODateTimeString(selectedDate[1]) +
      "&userId=" +
      UserId +
      "&token=" +
      localSettings.token;
    setReportContent(reportUrl);

    setIsLoading(false);
  };

  const onDateChange = (date) => {
    if (!Utils.IsNullOrEmptyArray(date)) {
      var dateArray = [moment(date[0]), moment(date[1])];
      if (dateArray[0]._isValid == false || dateArray[1]._isValid == false) {
        setMsgText(
          "Please select a valid date range."
        );
        setMsgOpen(true);
      }
      else {
        let dateDiff = dateArray[1].diff(dateArray[0], "days");
        if (dateDiff > ReportMaxDateLimit) {
          setMsgText(
            "Please note that the maximum date range you can select is 366 days. You can choose any start date within the past 366 days, but the end date cannot exceed this limit."
          );

          setMsgOpen(true);
        } else {
          setSelectedDate(dateArray);
        }
      }
    }
  };

  const checkAuthentication = () => {
    if (
      UserHelper.CheckPermission(EmployeeReportPage, navigate, localSettings)
    ) {
      const business = getBusiness();
      if (
        !Utils.IsNullOrEmptyObject(business) &&
        !Utils.IsNullOrEmptyArray(business.branchLocations)
      ) {
        setBranches(business.branchLocations);
      }
      setTechnicians();
    }
  };
  useEffect(() => {
    checkAuthentication();
  }, []);

  const handleSelect = (event) => {
    setSelectedBranch(event.target.value);
    if (!Utils.IsNullOrEmpty(event.target.value) && !Utils.IsNullOrEmptyArray(allTechnicians)) {
      var branchTechnicians = allTechnicians.filter((x) => x.branchId === event.target.value);
      setTechBranches(branchTechnicians);
    }
    else {
      setTechBranches(!Utils.IsNullOrEmptyArray(allTechnicians) ? allTechnicians : []);
    }
  };
  // const getTechnicians = async () => {
  //   setIsLoading(true);
  //   let result = await postAsync("Account/GetUsers", {
  //     // Role: UserRoles.Technician,
  //   });
  //   setIsNavigateToLogin(result.isNavigateToLogin);
  //   setIsLoading(false);
  //   if (result.error) {
  //     setMsgOpen(true);
  //     setMsgText(result.errorMessage);
  //     return;
  //   }
  //   return result.data.userProfiles;
  // };
  const getUsers = async () => {
    setIsLoading(true);
    let result = await postAsync(
      "Account/GetAccount",
      {},
      "",
      "GetAll",
      "AllUsersForBusiness",
      [localSettings?.business.id]
    );

    if (!Utils.IsNullOrEmptyArray(result.data)) {
      setIsLoading(false);
      return result.data;

    } else if (result.error) {
      setMsgOpen(true);
      setMsgText(result.errorMessage);
    }
    setIsLoading(false);
  };

  const setTechnicians = async () => {
    let technicians = await getUsers();
    const country = getCountry();
    if (CountryHelper.IsBusinessCountryIndia(country)) {
      technicians = technicians.filter((x) => x.role === UserRoles.Technician);
    }
    setAllTechnicians(technicians);
    if (!Utils.IsNullOrEmptyArray(technicians)) {
      if (!Utils.IsNullOrEmpty(selectedBranch)) {
        var branchTechnicians = technicians.filter((x) => x.branchId === selectedBranch);
        setTechBranches(technicians);
      }
      else
        setTechBranches(technicians);
    }
  };

  const handleTechSelect = (event) => {
    setSelectedTechBranch(event.target.value);
  };

  const handleBranchLabelClear = (event) => {
    setSelectedBranch(""); // Set the value to an empty string to clear the selection
    setSelectedBranch(event.target.value);
    setSelectedTechBranch(""); // Set the value to an empty string to clear the selection
  }

  const handleStaffLabelClear = (event) => {
    setSelectedTechBranch(""); // Set the value to an empty string to clear the selection
    setSelectedTechBranch(event.target.value);
  }

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <Loader open={isLoading} />
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />

        <Box>
          <Grid container m={0}>
            <SideBarMenuItems selectedTab={SideBarMenuNames.InvoiceReport} />
            <Grid xs={12} className="content-sec">
              <Grid container direction="row" className="">
                <ReportMenuItems
                  selectedMenu={SettingsMenuList.BusinessReports.Employee}
                />
                <Grid xs={12} md={9}>
                  <Grid spacing={2} className="form-sec">
                    <Stack
                      direction="row"
                      spacing={1}
                      className="card white-bg p-1 sticky-search-form"
                      justifyContent="space-between"
                    >
                      <Stack
                        spacing={1}
                        direction="row"
                        alignItems="center"
                      >
                        <FormControl
                          fullWidth
                          variant="outlined"
                          className="font-size-14"
                          sx={{ width: "220px" }}
                        >
                          <InputLabel id="Branch-label" sx={{ top: "-3px" }}>
                            Filter by Branch
                          </InputLabel>
                          <Select
                            value={selectedBranch}
                            onChange={handleSelect}
                            label="Branch Name"
                            style={{
                              height: "46px",
                            }}
                          >
                            {branches.map((branch, index) => (
                              <MenuItem key={index} value={branch.branchId}>
                                {branch.branchName}
                              </MenuItem>
                            ))}
                          </Select>
                          <Button className="clearBtn" title="Clear" onClick={handleBranchLabelClear}><ClearIcon /></Button>
                        </FormControl>
                        <FormControl
                          fullWidth
                          variant="outlined"
                          className="font-size-14"
                          sx={{ width: "200px" }}
                        >
                          <InputLabel id="Branch-label" sx={{ top: "-3px" }}>
                            Staff Name
                          </InputLabel>
                          <Select
                            value={selectedTechBranch}
                            onChange={handleTechSelect}
                            label="Tech. Name"
                            InputLabelProps={{ shrink: true }}
                            style={{
                              height: "46px",
                            }}
                          >
                            {!Utils.IsNullOrEmptyArray(techBranches) &&
                              techBranches.map((branch, index) => (
                                <MenuItem key={index} value={branch.id}>
                                  {branch.userName}
                                </MenuItem>
                              ))}
                          </Select>
                          <Button className="clearBtn" title="Clear" onClick={handleStaffLabelClear}><ClearIcon /></Button>
                        </FormControl>

                      </Stack>

                      <Stack
                        direction="row"
                        spacing={1}
                        style={{ height: "100%", alignItems: "center" }}
                      >
                        <Stack direction="row" margin="0 10px" style={{ height: "100%", border: "1px solid #b7c6dd", borderRadius: "4px", padding: "0 10px" }}>
                        <DateRangePicker
                          showLeadingZeros={true}
                          onChange={onDateChange}
                          maxDate={new Date()}
                          value={selectedDate}
                          locale={CountryHelper.GetDateCulture(localSettings.country.Culture)}
                          clearIcon={null}
                          calendarIcon={
                            <CalendarMonthOutlinedIcon
                              style={{
                                "font-size": "24px",
                                "align-self": "center",
                                color: "#666666",
                              }}
                            />
                          }
                        />
                        </Stack>
                        <FormControl>
                          <Button
                            className="btn btn-secondary"
                            variant="contained"
                            onClick={handleShowReport}
                          >
                            <AssessmentIcon fontSize="large" /> &nbsp;
                            Show Report
                          </Button>
                        </FormControl>
                        <FormControl>
                          <Tooltip title="Open in new tab" arrow="top">
                            <Button
                              className="btn btn-secondary"
                              variant="contained"
                              onClick={handleSubmit}
                            >
                              <OpenInNewIcon fontSize="large" /> &nbsp;
                            </Button>
                          </Tooltip>
                        </FormControl>
                      </Stack>
                    </Stack>

                    <iframe
                      className="reportIframe card white-bg mt-1"
                      src={reportContent}
                      style={{
                        width: "100%",
                        height: "calc(100vh - 180px)",
                      }}
                    ></iframe>
                    <br />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Container>
  );
};

export default JobcardsReport;
